module.exports = __webpack_public_path__ + "static/media/Arrow_Long_Right.32e131c4.svg";